"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useEffect, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import WaveDropPartContentMedias from "../drops/WaveDropPartContentMedias";
import WaveDropPartContentMarkdown from "../drops/WaveDropPartContentMarkdown";
import { ImageScale } from "@/helpers/image.helpers";
interface WaveSmallLeaderboardItemContentProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: () => void;
}
export const WaveSmallLeaderboardItemContent: React.FC<WaveSmallLeaderboardItemContentProps> = t0 => {
  const $ = _c(35);
  const {
    drop,
    onDropClick
  } = t0;
  const contentRef = useRef(null);
  const [showGradient, setShowGradient] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (contentRef.current) {
        setShowGradient(contentRef.current.scrollHeight > 208);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== drop) {
    t2 = [drop];
    $[1] = drop;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  const isStorm = drop.parts.length > 1;
  const haveMetadata = !!drop.metadata.length;
  let t3;
  if ($[3] !== drop.parts) {
    t3 = drop.parts.filter(_temp);
    $[3] = drop.parts;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const haveMedia = !!t3.length;
  let t4;
  if ($[5] !== drop.parts[0]) {
    t4 = !!drop.parts[0]?.media.length && <WaveDropPartContentMedias activePart={drop.parts[0]} disableMediaInteraction={true} imageScale={ImageScale.AUTOx450} />;
    $[5] = drop.parts[0];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== drop.mentioned_users || $[8] !== drop.parts[0] || $[9] !== drop.referenced_nfts || $[10] !== drop.wave) {
    t5 = <WaveDropPartContentMarkdown mentionedUsers={drop.mentioned_users} referencedNfts={drop.referenced_nfts} part={drop.parts[0]} wave={drop.wave} onQuoteClick={_temp2} />;
    $[7] = drop.mentioned_users;
    $[8] = drop.parts[0];
    $[9] = drop.referenced_nfts;
    $[10] = drop.wave;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== showGradient) {
    t6 = showGradient && <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-[1] tw-h-12 tw-bg-gradient-to-t tw-from-iron-900 tw-via-iron-900 tw-to-transparent" />;
    $[12] = showGradient;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== onDropClick || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div ref={contentRef} onClick={onDropClick} className="tw-relative tw-max-h-52 tw-cursor-pointer tw-space-y-3 tw-overflow-hidden">{t4}{t5}{t6}</div>;
    $[14] = onDropClick;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== drop.id || $[20] !== isStorm) {
    t8 = isStorm && <><svg className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-tooltip-id={`wave-storm-${drop.id}`}><path d="M3.75 13.5L14.25 2.25L12 10.5H20.25L9.75 21.75L12 13.5H3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-storm-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Storm</span></Tooltip></>;
    $[19] = drop.id;
    $[20] = isStorm;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== drop.id || $[23] !== haveMetadata) {
    t9 = !!haveMetadata && <><svg className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" aria-hidden="true" fill="none" data-tooltip-id={`wave-metadata-${drop.id}`}><path d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-metadata-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Metadata</span></Tooltip></>;
    $[22] = drop.id;
    $[23] = haveMetadata;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== drop.id || $[26] !== haveMedia) {
    t10 = !!haveMedia && <><svg className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" aria-hidden="true" fill="none" data-tooltip-id={`wave-media-${drop.id}`}><path d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-media-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Media</span></Tooltip></>;
    $[25] = drop.id;
    $[26] = haveMedia;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t8 || $[30] !== t9) {
    t11 = <div className="tw-mb-3 tw-mt-3 tw-flex tw-items-center tw-gap-x-2">{t8}{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t8;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t7) {
    t12 = <div>{t7}{t11}</div>;
    $[32] = t11;
    $[33] = t7;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
function _temp(part) {
  return !!part.media.length;
}
function _temp2() {}